import { computed } from 'mobx';
import MobxState from '../../../abstract/MobxState';
import { createObservableInstance } from '../../../helpers';
import PaymentsMapper from '../../wrappers/PaymentsMapper';

class PaymentsState extends MobxState {
  constructor(root) {
    super(root);

    this.parent = root;
    this.root = this.parent.root;
  }

  get data() {
    return this.root.payments.data?.filter(
      (docState) => docState?.data.tenancyUid === this.parent.id
    );
  }

  init() {
    super.init();

    this.mapped = createObservableInstance(PaymentsMapper, this);
  }
}

PaymentsState.annotations = {
  ...MobxState.annotations,
  data: computed,
};

export default PaymentsState;
